import { combineReducers } from 'redux'

import users from './users/reducer'
import orders from './orders/reducer'
import auth from './auth/reducer'
import analytics from './analytics/reducer'
import skills from './skills/reducer'
import cities from './cities/reducer'

const rootReducer = combineReducers({
  users,
  orders,
  auth,
  analytics,
  skills,
  cities,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/rootReducer.js